import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useDroppable } from '@dnd-kit/core';

import { DROPPABLE_ELEMENT_TYPES } from '../../../../../../../../../constants/dnd';
import PhotoGridCard from '../../../../../../../../../components/grid/components/PhotoGridCard';

const propTypes = {
  photo: PropTypes.shape({
    id: PropTypes.string,
  }),
  children: PropTypes.node,
  className: PropTypes.string,
};

const PhotoGridCardDroppable = ({ photo, children, className, ...props }) => {
  const { setNodeRef } = useDroppable({
    id: photo.id,
    data: {
      type: DROPPABLE_ELEMENT_TYPES.MANUAL_MATCHING_PHOTO_GRID_CARD,
      photo,
    },
  });

  const classes = classNames({
    'photo-grid-card-droppable': true,
    [className]: !!className,
  });

  return (
    <div className={classes} ref={setNodeRef}>
      <PhotoGridCard photo={photo} {...props}>
        {children}
      </PhotoGridCard>
    </div>
  );
};

PhotoGridCardDroppable.propTypes = propTypes;

export default PhotoGridCardDroppable;
